import ITrackingObject from '../interfaces/tracking-object.interface';
import {
	Tracker,
	Product,
	ITrackingData,
} from '@studyportals/datalake-event-tracker';

export default class Tracking {
	private dataLakeEventTracker: Tracker;

	constructor() {
		this.dataLakeEventTracker = new Tracker(Product.BESTFIT_OVERVIEW);
	}

	public snowPlow(trackingParams: ITrackingObject): void | null {
		try {
			this.dataLakeEventTracker.trackStructuredEvent(
				trackingParams as ITrackingData,
			);
		} catch (error) {
			console.warn('tracking failed: ', error);
		}
	}
}
